import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";

import { styles } from "./CustomCheckBoxStyles";

const CheckBoxItem = ({ item, formData, setFormData, isReadOnly }) => {
  const { label, required, name, customLabelStyles, isDisabled, customOuterContainerStyles, handleChange } = item;
  return (
    <Box sx={{ ...customOuterContainerStyles }}>
      <FormControlLabel
        required={required || false}
        control={
          <Checkbox
            disabled={isDisabled?.() || isReadOnly || false}
            checked={formData[name]}
          />
        }
        sx={styles.checkBoxStyle}
        onChange={(e) => {
          (handleChange && handleChange(e)) ||
            setFormData((prevData) => ({
              ...prevData,
              [name]: e.target.checked,
            }));
        }}
        label={
          <Typography sx={{ ...styles.labelStyle, ...customLabelStyles }}>
            {label}
          </Typography>
        }
      />
    </Box>
  );
};

const CustomCheckBoxGroup = ({ columns, setFormData, formData, isReadOnly }) => {
  const midpoint = Math.ceil(columns?.length / 2);
  const leftColumn = columns?.slice(0, midpoint) || [];
  const rightColumn = columns?.slice(midpoint) || [];

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={6} md={6}>
        {leftColumn.map((item, index) => (
          <CheckBoxItem
            key={index}
            item={item}
            formData={formData}
            setFormData={setFormData}
            isReadOnly={isReadOnly}
          />
        ))}
      </Grid>
      <Grid item xs={12} sm={6} md={6}>
        {rightColumn.map((item, index) => (
          <CheckBoxItem
            key={index}
            item={item}
            formData={formData}
            setFormData={setFormData}
            isReadOnly={isReadOnly}
          />
        ))}
      </Grid>
    </Grid>
  );
};

export default CustomCheckBoxGroup;
